import React from 'react';
import { Controller } from 'react-hook-form';
import PropTypes from 'prop-types';
import translateRHFErrorMsg from 'Helpers/TranslateRHFErrorMsg';
import Switch from '../Switch';

export default function SwitchController({ name, control, rules, defaultValue = false, ...otherProps }) {
    return (
        <Controller
            control={control}
            name={name}
            rules={rules}
            render={({ field: { value, ref, ...otherRenderProps }, fieldState: { error } }) => (
                <Switch
                    helperText={translateRHFErrorMsg(error)}
                    error={Boolean(error)}
                    checked={value}
                    {...otherProps}
                    {...otherRenderProps}
                />
            )}
            defaultValue={defaultValue}
        />
    );
}

SwitchController.propTypes = {
    control: PropTypes.object.isRequired,
    name: PropTypes.string.isRequired,
    rules: PropTypes.object,
};
